import {
  FieldMappingFieldItem,
  FieldMappingGroup,
  FieldType,
  VariableValue,
} from '@components/text-editors/addons/field-mapping';

import { MappableVariable } from 'api/types';

export const filterSelectAttributeVariables = (
  fields: FieldMappingFieldItem[]
): FieldMappingFieldItem[] => {
  const seenBySourceAndLabel = new Set<string>();

  return fields.reduce((acc, field) => {
    if (field.type === 'select') {
      const baseLabel = field.label.replace(/\s*\((value|label)\)$/, '');
      const key = `${field.source}::${baseLabel}`;
      if (!seenBySourceAndLabel.has(key)) {
        seenBySourceAndLabel.add(key);
        acc.push({
          ...field,
          field: 'value',
          label: baseLabel,
        });
      }
    } else if (field.type === 'multi_select') {
      const baseLabel = field.label.replace(/\s*\((values|labels)\)$/, '');
      const key = `${field.source}::${baseLabel}`;
      if (!seenBySourceAndLabel.has(key)) {
        seenBySourceAndLabel.add(key);
        acc.push({
          ...field,
          field: 'values',
          label: baseLabel,
        });
      }
    } else {
      acc.push(field);
    }
    return acc;
  }, [] as FieldMappingFieldItem[]);
};

export const findMappedField = (
  formValue: VariableValue | undefined,
  variableGroups: FieldMappingGroup[]
): FieldMappingFieldItem | undefined => {
  if (!formValue || !formValue.variables) {
    return undefined;
  }
  const variable = Object.values(formValue.variables)[0];
  if (variable?.source === 'action') {
    const action = variableGroups.find((group) => group.id === variable.action);
    if (action) {
      return action.fields.find((field) => field.field === variable.field);
    }
  } else {
    return variableGroups
      .flatMap((obj) => obj.fields)
      .find((field) => field.source === variable?.source && field.field === variable?.field);
  }
};

export const findValueType = (mappedField?: FieldMappingFieldItem): string => {
  const typeMapping: Partial<Record<FieldType, string>> = {
    select: 'select',
    multi_select: 'multi_select',
    date: 'date',
    boolean: 'boolean',
    file: 'file',
    number: 'number',
    text: 'text',
    decimal: 'number',
  };

  return typeMapping[mappedField?.type ?? 'text'] ?? 'text';
};

export const findValueOptions = (mappedField?: FieldMappingFieldItem) => {
  if (mappedField?.options) {
    return mappedField.options.map((option) => {
      const label = 'display' in option ? option.display : option.label;
      const tooltip = typeof label === 'string' ? label : undefined;
      const optionValue = ('short_id' in option ? option.short_id : option.value) as string;
      return {
        value: optionValue,
        label,
        tooltip,
      };
    });
  }
  return [];
};

export const getFieldLabel = (field: VariableValue): string | undefined => {
  if (!field?.variables) {
    return undefined;
  }
  const variable = Object.values(field.variables)[0] as MappableVariable;
  return variable?.label;
};
